<template>
  <div class="inline">
    <button type="button" class="fa-light fa-list-check pulsante_comando js-tooltip" @click="openModal()"></button>
    <whitelistActivities
      :guestBusinessUnitId="guest_business_unit_id"
      :guestPeriodDataSetId="guest_period_data_set_id"
      :startPeriod="start_period"
      :superUser="super_user"
      :blockBomSend="block_bom_send"
      @modalClosed="closeModal"
      v-if="modalOpened"
    ></whitelistActivities>
  </div>
</template>

<script>
import whitelistActivities from './whitelistActivities';

export default {
  name: 'whitelistActivitiesContainer',
  components: {
    whitelistActivities,
  },
  props: {
    guest_business_unit_id: {
      type: Number,
      required: true,
    },
    guest_period_data_set_id: {
      type: Number,
      required: true,
    },
    start_period: {
      type: String,
      required: true,
    },
    super_user: {
      type: Boolean,
      required: true,
    },
    block_bom_send: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      modalOpened: false,
    };
  },
  watch: {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    console.log('Mounted whitelistActivitiesContainer');
  },
  methods: {
    openModal() {
      this.modalOpened = true;
    },
    closeModal() {
      console.log('OnCloseModal');
      this.modalOpened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: white;
}

.inline {
  display: inline-block;
}
</style>
